export default {
  submitButton: {
    id: 'checkout_step_addresses_submit_button',
    defaultMessage: 'Next',
  },
  nextErrorToastTitle: {
    id: 'checkout_step_next_error_toast_title',
    defaultMessage: 'Unable to continue',
  },
  nextErrorToastDescription: {
    id: 'checkout_step_next_error_toast_description',
    defaultMessage:
      'Please save your address changes before continuing to payment.',
  },
  bouyguesShippingAddressErrorToastTitle: {
    id: 'checkout_step_bouygues_shipping_address_error_toast_title',
    defaultMessage: 'Incorrect shipping address',
  },
  bouyguesBillingAddressErrorToastTitle: {
    id: 'checkout_step_bouygues_billing_address_error_toast_title',
    defaultMessage: 'Incorrect billing address',
  },
  bouyguesAddressErrorToastDescription: {
    id: 'checkout_step_bouygues_shipping_address_error_toast_description',
    defaultMessage:
      'There was an error saving your address. Please check the details and try again.',
  },
}
